import { useState, useEffect } from 'react';

import { cohortsApi } from '../api';
import type { FacilitatorStatus } from '../types';

export interface UseFacilitatorStatusResult {
  status: FacilitatorStatus | null;
  loaded: boolean;
  /** True only for full facilitators — co-facilitators must not gain cohort creation. */
  canCreateCohorts: boolean;
}

/**
 * Fetches the current user's facilitator status once on mount. `loaded` flips
 * true on both success and error, so callers can distinguish "still fetching"
 * from "fetched but unavailable".
 */
export const useFacilitatorStatus = (): UseFacilitatorStatusResult => {
  const [status, setStatus] = useState<FacilitatorStatus | null>(null);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    cohortsApi.getFacilitatorStatus(
      (data) => {
        setStatus(data);
        setLoaded(true);
      },
      () => setLoaded(true),
    );
  }, []);

  const canCreateCohorts = status?.facilitator_type === 'facilitator';

  return { status, loaded, canCreateCohorts };
};
